import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Tue Aug 07 2018
 * @author BPo
 */


import api from '../../api';
import { CONSTANTS } from '../../../constants';
import { jsonConversions, UserProfileConverter, SubstitutedUserConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
/**
 * Transport layer for the `User` profile.
 *
 * FIXME: Probably should be renamed to the UserLayer with custom loadProfile method.
 */

export var ProfileLayer =
/*#__PURE__*/
function () {
  function ProfileLayer() {
    _classCallCheck(this, ProfileLayer);
  }

  _createClass(ProfileLayer, [{
    key: "loadProfile",

    /**
     * Load profile for the current logged in user.
     */
    value: function loadProfile() {
      var _this = this;

      var findPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.USER_PROFILE)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this.userProfileConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return findPromise;
    }
  }, {
    key: "findSubstitutors",
    value: function findSubstitutors() {
      var _this2 = this;

      var findPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.USER_SUBSTITUTED)).get({
        responseType: 'json'
      }).then(function (response) {
        var substitutedUsers = [];
        (response.data.result || []).map(function (substitutedUser) {
          substitutedUsers.push(_this2.substitutedUserConverter.toObject(substitutedUser, jsonConversions));
        });
        return substitutedUsers;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return findPromise;
    }
  }, {
    key: "getUsers",
    value: function getUsers(userIds) {
      var _this3 = this;

      var getUsersPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.USERS)).post({
        userIds: userIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var users = [];
        (response.data || []).map(function (user) {
          users.push(_this3.userProfileConverter.toObject(user, jsonConversions));
        });
        return users;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return getUsersPromise;
    }
  }]);

  return ProfileLayer;
}();

__decorate([Inject, __metadata("design:type", UserProfileConverter)], ProfileLayer.prototype, "userProfileConverter", void 0);

__decorate([Inject, __metadata("design:type", SubstitutedUserConverter)], ProfileLayer.prototype, "substitutedUserConverter", void 0);